(ns frontend.react.virtualized.scrollable-grid.selection-grid
  (:require [reagent.core :as r]
            [frontend.utils :as fu]))

(defn render-cell [props row-index style render-key]
  (let [{:keys [columns row-data-getter on-cell-click hover-atom hover-col hover-row
                on-row-select! avail-width resizing-column editable-grid? on-row-click!]} props
        hovering-row? (= row-index hover-row)
        hovering-col? (= -1 hover-col)
        checked? (boolean (:selected (row-data-getter row-index)))]

    (r/as-element [:div
                   {:key           render-key
                    :style         style
                    :class-name    (fu/cs "w-[31px] px-2 flex items-center bg-base-light border-b-2 border-s border-e-2 border-solid border-base-light-border-paler clickable even"
                                          (when hovering-col?
                                            "hover-col")
                                          (when hovering-row?
                                            "hover-row")
                                          (when (and (contains? (-> @hover-atom :drag) :column)
                                                     (nil? (-> @hover-atom :drag :column)))
                                            "drag-over-column")
                                          (if (odd? row-index)
                                            "odd"
                                            "even"))
                    :on-mouse-over (fn [_]
                                     (swap! hover-atom assoc :hover {:col -1
                                                                     :row row-index}))}
                   [:i
                    {:class-name (fu/cs "fal"
                                        (if checked?
                                          "fas fa-check-square"
                                          "fa-square"))
                     :on-click   #(on-row-select! row-index (not checked?))}]
                   #_(when (and hovering-row?)
                       [avail-width row-index])])))

(defn render-selection-cell [props js-args]
  (let [{:keys [columns row-data-getter on-cell-click hover-atom hover-col hover-row
                on-row-select! avail-width editable-grid? on-row-click!]} props
        {:keys [index isScrolling isVisible key parent style] :as args} (js->clj js-args :keywordize-keys true)]
    [render-cell props index style key]))

(defn view [args]
  (fn [args]
    (let [{:keys [columns col-count row-height header-height avail-height overscan-count row-count
                  hover-atom hover-row hover-col select-width
                  scroll-top on-scroll editable-grid? on-row-click!]} args]
      [:div.zap-grid__scrollable__selection-container
       {:style {:top (str header-height "px")}}             ;; TODO can we handle the header sizings in css with .filters-open class or something
       (r/as-element
        (into
         [:> js/ReactVirtualized.List
          {:class-name            "zap-grid__header"
           :row-renderer          (partial render-selection-cell args)
           :column-width          select-width
           :column-count          1
           :width                 select-width
           :height                avail-height
           :overscan-column-count overscan-count
           :row-height            (or row-height 40)
           :overscan-row-count    overscan-count
           :scroll-top            scroll-top
           :on-scroll             on-scroll
           :row-count             row-count
           :no-content-renderer   (fn [_] (str "NO content " (count columns)))
           :ref                   (fn [args]
                                    ;; todo: save grid ref here
                                    )}]))])))
